module.exports = __webpack_public_path__ + "img/card-communities.cae85814.jpg";